import React from 'react'

import {H3, H5, Button, Alert} from '../../../../components/UI/index.js'
import {FormStack, Toggle, Input, Select} from '../../../../components/UI/forms/index.js'
import LoginActions from '../../../../actions/LoginActions.js'
import {Customer} from '../../../../../server/functions/customers/customers.types.js'

interface ShopwareSettingsProps {
    user: Customer
    onChange: (user: Customer, save?: boolean) => void
}

interface ShopwareSettingsState {
    error: string
    verified: boolean
    loading: boolean
}

class ShopwareSettings extends React.Component<ShopwareSettingsProps, ShopwareSettingsState> {
    constructor(props) {
        super(props)

        this.state = {error: '', verified: false, loading: false}
    }

    onChangeChecked(key, event) {
        const {user, onChange} = this.props

        user.settings.webshops.shopware[key] = event.target.checked

        onChange(user)
    }

    onChangeValue(key: string, event: React.ChangeEvent<HTMLInputElement>, parser?: (value: string) => number) {
        const {user, onChange} = this.props

        user.settings.webshops.shopware[key] = parser ? parser(event.target.value) : event.target.value

        onChange(user)
    }

    onVerifyConnection() {
        const {user, onChange} = this.props

        this.setState({loading: true, verified: false, error: ''})

        onChange(user, true)

        setTimeout(() => { // wait for saving
            LoginActions.verifyWebshop('shopware', (err) => {
                if (err) {
                    this.setState({loading: false, error: `Verificatie niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`})
                } else {
                    this.setState({loading: false, error: '', verified: true})
                }
            })
        }, 1000)
    }

    render() {
        const {user} = this.props
        const {error, verified, loading} = this.state

        return (
            <div>
                <H3 style={{marginBottom: 36}}>Shopware</H3>

                <H5 style={{marginBottom: 24}}>Instellingen</H5>

                <FormStack>
                    <Toggle
                        label='Actief'
                        checked={user.settings.webshops.shopware.active}
                        onChange={this.onChangeChecked.bind(this, 'active')}
                    />

                    {user.settings.webshops.shopware.active &&
                        <>
                            <Input
                                label='Webshop URL'
                                value={user.settings.webshops.shopware.url}
                                onChange={this.onChangeValue.bind(this, 'url')}
                            />

                            <Input
                                label='Access Key ID'
                                value={user.settings.webshops.shopware.clientId}
                                onChange={this.onChangeValue.bind(this, 'clientId')}
                            />

                            <Input
                                label='Secret Access Key'
                                value={user.settings.webshops.shopware.clientSecret}
                                onChange={this.onChangeValue.bind(this, 'clientSecret')}
                            />

                            <Select
                                label='Additional address field 1'
                                info='Additional address field 1 in Shopware wordt eventueel gebruikt voor Huisnummer, Toevoeging, Huisnummer + toevoeging of 2e adres regel'
                                value={user.settings.webshops.shopware.additionalAddressField1}
                                onChange={this.onChangeValue.bind(this, 'additionalAddressField1')}
                            >
                                <option value=''>N.v.t.</option>
                                <option value='nr'>Huisnummer</option>
                                <option value='addition'>Toevoeging</option>
                                <option value='nrAndAddition'>Huisnummer + Toevoeging</option>
                                <option value='street2'>2e adres regel</option>
                            </Select>

                            <Select
                                label='Additional address field 2'
                                info='Additional address field 2 in Shopware wordt eventueel gebruikt voor Huisnummer, Toevoeging, Huisnummer + toevoeging of 2e adres regel'
                                value={user.settings.webshops.shopware.additionalAddressField2}
                                onChange={this.onChangeValue.bind(this, 'additionalAddressField2')}
                            >
                                <option value=''>N.v.t.</option>
                                <option value='nr'>Huisnummer</option>
                                <option value='addition'>Toevoeging</option>
                                <option value='nrAndAddition'>Huisnummer + Toevoeging</option>
                                <option value='street2'>2e adres regel</option>
                            </Select>

                            <Input
                                type='number'
                                min={1}
                                max={180}
                                label='Aantal dagen terugkijken voor ophalen bestellingen'
                                value={user.settings.webshops.shopware.nrOfDays || 7}
                                onChange={(event) => this.onChangeValue('nrOfDays', event, parseInt)}
                            />

                            <Select
                                label='Update bestelling status in Shopware'
                                info=''
                                value={user.settings.webshops.shopware.updateStatus}
                                onChange={this.onChangeValue.bind(this, 'updateStatus')}
                            >
                                <option value=''>Nooit</option>
                                <option value='confirm'>Na bevestigen</option>
                                <option value='afterSent'>Na verzenden</option>
                            </Select>

                            <Toggle
                                label='Alleen betaalde bestellingen importeren'
                                checked={user.settings.webshops.shopware.ignoreNotPaidOrders}
                                onChange={this.onChangeChecked.bind(this, 'ignoreNotPaidOrders')}
                            />

                            <Toggle
                                label='Consument opmerking meegeven als bezorginstructie'
                                checked={user.settings.webshops.shopware.useComment}
                                onChange={(event) => this.onChangeChecked('useComment', event)}
                            />

                            <Button
                                variant='text'
                                loading={loading}
                                onClick={this.onVerifyConnection.bind(this)}
                            >
                                Verifieer
                            </Button>

                            {error && (
                                <Alert style={{marginBottom: 6}} onClose={() => this.setState({error: ''})} variant='error'>{error}</Alert>
                            )}

                            {!error && verified && (
                                <Alert style={{marginBottom: 6}} onClose={() => this.setState({verified: false})}>Verificatie succesvol.</Alert>
                            )}

                        </>
                    }
                </FormStack>
            </div>
        )
    }
}

export default ShopwareSettings
